module.exports = __webpack_public_path__ + "static/img/63.bacd8f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/63.png
// module id = yodM
// module chunks = 1